<template>
  <div id="settings" class="container">
    <v-dialog v-model="domains.deleteModal" width="400">
      <v-card class="rounded-xl" elevation="7">
        <v-card-title>Deleting Domain</v-card-title>
        <v-card-text
          >Are you sure you want to delete {{ domains.item.domain }}? All users
          that have this domain assigned will be reset back to
          {{ $store.state.site.hostname }}, and the zone will be removed from
          Cloudflare.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="rounded-xl"
            color="primary"
            text
            @click="domains.deleteModal = false"
          >
            Cancel
          </v-btn>
          <v-btn
            class="rounded-xl"
            :loading="domains.deleteLoading"
            color="red"
            text
            @click="doDeleteDomain()"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="users.purgeGallery.dialog" width="400">
      <v-card class="rounded-xl" elevation="7">
        <v-card-title>Purge Gallery of User</v-card-title>
        <v-card-text
          >Are you sure you want to delete all of
          {{ users.purgeGallery.user.username }}'s gallery.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="rounded-xl"
            color="primary"
            text
            @click="users.purgeGallery.dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            class="rounded-xl"
            :loading="users.purgeGallery.loading"
            color="red"
            text
            @click="doPurgeGallery()"
          >
            Purge
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card v-if="$store.state.user.admin" class="rounded-xl" elevation="7">
      <v-tabs color="#007aff">
        <v-tab>
          <v-icon left> mdi-view-dashboard</v-icon>
          Website
        </v-tab>
        <v-tab>
          <v-icon left> mdi-account-group</v-icon>
          Users
        </v-tab>
        <v-tab>
          <v-icon left> mdi-bug</v-icon>
          Feedback
        </v-tab>
        <v-tab>
          <v-icon left> mdi-web</v-icon>
          Domains
        </v-tab>
        <v-tab>
          <v-icon left> mdi-plus</v-icon>
          Invites
        </v-tab>
        <v-tab>
          <v-icon left> mdi-gift-outline</v-icon>
          InvitesV2
        </v-tab>
        <v-tab v-if="$store.state.site.release === 'dev'">
          <v-icon left> mdi-flag</v-icon>
          Reports
        </v-tab>
        <v-tab v-if="$store.state.site.release === 'dev'">
          <v-icon left> mdi-bug</v-icon>
          Development Options
        </v-tab>
        <v-tab-item>
          <v-card rounded>
            <v-container>
              <v-form>
                <p class="text-h5">Create Announcement</p>
                <v-textarea
                  v-model="announcement.content"
                  :outlined="!$store.state.site.whitelabel"
                  label="Content"
                >
                </v-textarea>
                <v-select
                  v-if="$store.state.site.release === 'dev'"
                  v-model="announcement.type"
                  :items="announcement.types"
                  :outlined="!$store.state.site.whitelabel"
                  item-text="Types"
                  label="Alert Type (Cut Feature)"
                ></v-select>
                <v-btn
                  class="rounded-xl"
                  :loading="announcement.loading"
                  @click="createAnnouncement()"
                >
                  Create
                </v-btn>
              </v-form>
            </v-container>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card rounded>
            <div class="container">
              <v-data-table
                :headers="users.headers"
                :items="users.users"
                :search="users.search"
                class="rounded-xl elevation-12"
              >
                <template v-slot:top>
                  <v-toolbar class="rounded-xl">
                    <v-toolbar-title>Table of Users</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-text-field
                      class="rounded-xl"
                      v-model="users.search"
                      :outlined="!$store.state.site.whitelabel"
                      append-icon="mdi-magnify"
                      hide-details
                      label="Search"
                    ></v-text-field>
                    <v-dialog v-model="users.dialog" max-width="500px">
                      <v-card class="rounded-xl" elevation="7">
                        <v-card-title>
                          <span class="text-h5"
                            >Editing: {{ users.editedItem.username }} ({{
                              users.editedItem.id
                            }})</span
                          >
                        </v-card-title>

                        <v-card-text>
                          <v-container>
                            <v-alert icon="mdi-credit-card" type="info">
                              <v-select
                                v-model="users.editedItem.planId"
                                :items="users.plans"
                                color="white"
                                item-text="internalName"
                                item-value="id"
                                label="Plan"
                                text-color="white"
                              ></v-select>
                              <v-text-field
                                class="rounded-xl"
                                v-model="users.editedItem.subscriptionExpiry"
                                color="white"
                                label="Plan Expiry"
                                readonly
                                text-color="white"
                                @click="users.subscriptionDialog = true"
                              ></v-text-field>
                              <v-dialog
                                ref="dialog"
                                v-model="users.subscriptionDialog"
                                :return-value.sync="
                                  users.editedItem.subscriptionExpiry
                                "
                                width="290px"
                              >
                                <v-date-picker
                                  v-model="users.editedItem.subscriptionExpiry"
                                  color="primary"
                                  scrollable
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    class="rounded-xl"
                                    color="primary"
                                    text
                                    @click="
                                      $refs.dialog.save(
                                        users.editedItem.subscriptionExpiry
                                      )
                                    "
                                  >
                                    OK
                                  </v-btn>
                                </v-date-picker>
                              </v-dialog>
                            </v-alert>
                            <v-row>
                              <v-col cols="12" md="4" sm="6">
                                <v-checkbox
                                  v-model="users.editedItem.banned"
                                  label="Banned"
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="12" md="4" sm="6">
                                <v-checkbox
                                  v-model="users.editedItem.administrator"
                                  label="Admin"
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="12" md="4" sm="6">
                                <v-checkbox
                                  v-model="users.editedItem.moderator"
                                  label="Moderator"
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            class="rounded-xl"
                            color="blue darken-1"
                            text
                            @click="close"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            class="rounded-xl"
                            :loading="users.loading"
                            color="blue darken-1"
                            text
                            @click="save(users.editedItem)"
                          >
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-dialog v-model="users.dialogDelete" max-width="500px">
                      <v-card class="rounded-xl" elevation="7">
                        <v-card-title class="text-h5"
                          >Are you sure you want to delete this item?
                        </v-card-title>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            class="rounded-xl"
                            color="blue darken-1"
                            text
                            @click="closeDelete"
                            >Cancel
                          </v-btn>
                          <v-btn
                            class="rounded-xl"
                            color="blue darken-1"
                            text
                            @click="deleteItemConfirm"
                            >OK
                          </v-btn>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon class="mr-2" small @click="editItem(item)">
                    mdi-pencil
                  </v-icon>
                  <v-icon small @click="banUser(item)"> mdi-gavel</v-icon>
                  <v-icon small @click="inviteBanUser(item)"> mdi-plus</v-icon>
                  <v-icon small @click="purgeGalleryDialog(item)">
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
            </div>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-toolbar color="toolbar">
            <v-toolbar-title>Feedback ({{ feedback.length }})</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="getFeedback" icon>
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container :fluid="$vuetify.breakpoint.lgAndDown">
            <v-card
              v-for="item in feedback"
              :key="item.id"
              class="rounded-xl mb-2"
              color="card"
            >
              <v-toolbar color="toolbar">
                <v-toolbar-title>
                  Feedback -
                  {{ item.user?.username }}
                </v-toolbar-title>
              </v-toolbar>
              <v-container :fluid="$vuetify.breakpoint.lgAndDown">
                {{ item.feedbackText.substring(0, 1000) }}
                <br />
                <small v-if="item.user">
                  User ID: {{ item.user.id }}<br />Username:
                  {{ item.user.username }}<br />Route: {{ item.route
                  }}<br />Rating: {{ item.starRating }}<br />
                  Created At:
                  {{
                    $date(item.createdAt).format("YYYY-MM-DD hh:mm A")
                  }}</small
                >
              </v-container>
            </v-card>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container>
            <v-data-table
              :headers="domains.headers"
              :items="domains.domains"
              class="rounded-xl elevation-12"
            >
              <template v-slot:top>
                <v-toolbar class="rounded-xl">
                  <v-toolbar-title>Domains</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
              <template v-slot:item="row">
                <tr>
                  <td>{{ row.item.domain }}</td>
                  <td>{{ row.item.user.username }}</td>
                  <td>{{ row.item.active }}</td>
                  <td>
                    <v-btn class="rounded-xl" @click="deleteDomain(row.item)">
                      Delete</v-btn
                    >
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container>
            <h2 style="background-color: red">
              Users can no longer register with InviteKeys (InvitesV1)!
            </h2>
            <br />
            <v-btn
              class="rounded-xl"
              :loading="invites.loading"
              @click="doInviteEntitlement(1)"
              >Generate an Invite Wave
            </v-btn>
            <br />
            <small
              >Users that are invite entitlement banned will not get an invite
              entitlement added to their account.</small
            >
            <p>Grant user an invite.</p>
            <v-text-field
              class="rounded-xl"
              v-model="invites.username"
              :outlined="!$store.state.site.whitelabel"
              label="Username"
            ></v-text-field>
            <v-text-field
              class="rounded-xl"
              v-model="invites.count"
              :outlined="!$store.state.site.whitelabel"
              label="Amount"
            ></v-text-field>
            <v-btn
              class="rounded-xl"
              :disabled="!invites.username"
              :loading="invites.loadingUser"
              @click="doInviteEntitlementForUser(invites.count)"
              >Grant
            </v-btn>
            <p v-if="$store.state.site.release === 'dev'">Lookup Invite</p>
            <v-text-field
              class="rounded-xl"
              v-if="$store.state.site.release === 'dev'"
              v-model="invites.lookup.invite"
              label="Invite"
            ></v-text-field>
            <v-checkbox
              v-if="$store.state.site.release === 'dev'"
              :label="'Lookup by ID' || 'Lookup by Invite Name'"
            ></v-checkbox>
            <v-btn
              class="rounded-xl"
              v-if="$store.state.site.release === 'dev'"
              :disabled="!invites.lookup.invite"
              :loading="invites.lookup.loading"
              @click="doInviteLookup()"
              >Lookup
            </v-btn>
            <br />
            <p v-if="invites.lookup.result.invite.id">
              Invite Key ID: {{ invites.lookup.result.invite.id }}
            </p>
            <p v-if="invites.lookup.result.invite.id">
              Invite Created By Username:
              {{ invites.lookup.result.invite.user.username }}
            </p>
            <p v-if="invites.lookup.result.invite.id">
              Invite Used By Username:
              {{ invites.lookup.result.usedBy.username }}
            </p>
            <p v-if="invites.lookup.result.invite.id">
              Active: {{ invites.lookup.result.invite.active }}
            </p>
            <p v-if="invites.lookup.result.invite.id">
              Created:
              {{
                dayjs(invites.lookup.result.invite.createdAt).format(
                  "Do of MMMM YYYY, h:mm:ss a"
                )
              }}
            </p>
            <p v-if="invites.lookup.result.invite.id">
              Expiry:
              {{
                dayjs(invites.lookup.result.invite.expiredAt).format(
                  "Do of MMMM YYYY, h:mm:ss a"
                )
              }}
            </p>
            <br />
            <v-data-table
              :headers="invites.headers"
              :items="invites.inviteKeys"
              class="rounded-xl elevation-12"
            >
              <template v-slot:top>
                <v-toolbar class="rounded-xl">
                  <v-toolbar-title
                    >Active Invites in Circulation
                  </v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
              <template v-slot:item="row">
                <tr>
                  <td>{{ row.item.inviteKey }}</td>
                  <td>{{ row.item.active }}</td>
                  <td>
                    {{
                      dayjs(row.item.createdAt).format(
                        "Do of MMMM YYYY, h:mm:ss a"
                      )
                    }}
                  </td>
                  <td>{{ row.item.expiredAt }}</td>
                  <td>
                    <v-btn
                      class="rounded-xl"
                      v-if="row.item.active"
                      @click="invalidate(row.item)"
                    >
                      Invalidate
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container>
            <v-data-table :headers="invitesV2.headers" :items="invitesV2.rows">
              <template v-slot:top>
                <v-toolbar class="rounded-xl">
                  <v-toolbar-title>InvitesV2/Invite a Friend</v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-slot:item.actions="{ item }">
                <!-- X and tick icon buttons-->
                <v-btn
                  icon
                  small
                  v-if="item.status === 'pending'"
                  @click="actInvitesV2('accepted', item)"
                >
                  <v-icon>mdi-check</v-icon>
                </v-btn>
                <v-btn
                  icon
                  small
                  class="ml-5"
                  v-if="item.status === 'pending'"
                  @click="actInvitesV2('rejected', item)"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container>
            <v-row>
              <v-col v-for="report in reports.reports" :key="report.id">
                <v-card class="text-center justify-center" elevation="24">
                  <v-card-title
                    v-if="!report.upload"
                    class="justify-center text-h5"
                    >{{ report.reportedUser.username }}
                  </v-card-title>
                  <v-card-title
                    v-if="report.upload"
                    class="justify-center text-h5"
                    >{{ report.upload.name }}
                  </v-card-title>
                  <p v-if="report.reportedUser">
                    User Reported: {{ report.reportedUser.username }}
                  </p>
                  <p v-if="report.reportedByUser">
                    Reported by: {{ report.reportedByUser.username }}
                  </p>
                  <v-img
                    v-if="report.upload"
                    :src="'/i/' + report.upload.attachment"
                    contain
                    height="220"
                  ></v-img>
                  <v-btn class="rounded-xl" color="success">
                    <v-icon>mdi-delete</v-icon>
                    Delete Item, Ban User, and Delete Report
                  </v-btn>
                  <v-btn class="rounded-xl" color="success">
                    <v-icon>mdi-delete</v-icon>
                    Delete Item, and Delete Report
                  </v-btn>
                </v-card>
              </v-col>
            </v-row>
            <v-pagination
              v-if="reports.reports.length"
              v-model="reports.page"
              :length="reports.pager.totalPages"
              :total-visible="10"
            ></v-pagination>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container>
            <p v-if="debug.users.user">{{ debug.users.user.username }}</p>
            <v-btn class="rounded-xl" @click="addUserDebug">Add RNG User</v-btn>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-card>
    <v-card v-if="!$store.state.user.admin" class="rounded-xl" elevation="7">
      <v-container>
        You do not have permission to access this page.
      </v-container>
    </v-card>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"
import dayjs from "dayjs"
const advancedFormat = require("dayjs/plugin/advancedFormat")
dayjs.extend(advancedFormat)

export default {
  name: "Admin",
  data() {
    return {
      feedback: [],
      announcement: {
        type: "info",
        content: "",
        loading: false,
        types: ["success", "info", "warning", "error"]
      },
      debug: {
        users: {
          user: null,
          loading: false
        }
      },
      reports: {
        page: 1,
        reports: [],
        pager: []
      },
      invitesV2: {
        loading: false,
        rows: [],
        headers: [
          {
            text: "Email",
            value: "email"
          },
          {
            text: "Inviter",
            value: "user.username"
          },
          {
            text: "Invitee",
            value: "invited.username"
          },
          {
            text: "Invite Key",
            value: "inviteKey"
          },
          {
            text: "Created At",
            value: "createdAt"
          },
          {
            text: "Status",
            value: "status"
          },
          {
            text: "Actions",
            value: "actions"
          }
        ]
      },
      invites: {
        loading: false,
        lookup: {
          invite: "",
          loading: false,
          result: {
            invite: {
              id: null,
              active: false
            }
          }
        },
        entitlementWaves: {
          amount: ""
        },
        inviteKeys: [],
        count: null,
        usersInvited: 0,
        username: "",
        loadingUser: false,
        headers: [
          { text: "Invite Key", value: "inviteKey" },
          { text: "Active", value: "active" },
          { text: "Created at", value: "createdAt" },
          { text: "Expiry", value: "expiredAt" },
          { text: "Options", value: "options" }
        ]
      },
      users: {
        search: "",
        loading: false,
        subscriptionDialog: false,
        dialog: false,
        dialogDelete: false,
        users: [],
        plans: [],
        purgeGallery: {
          user: [],
          dialog: false,
          loading: false
        },
        headers: [
          { text: "ID", value: "id", align: "start" },
          { text: "Username", value: "username" },
          { text: "Email", value: "email" },
          { text: "Plan", value: "plan.internalName" },
          { text: "Admin", value: "administrator" },
          { text: "Moderator", value: "moderator" },
          { text: "Credits", value: "credits" },
          { text: "Banned", value: "banned" },
          { text: "Invite Banned", value: "inviteEntitlementBan" },
          { text: "Created at", value: "createdAt" },
          { text: "Actions", value: "actions", sortable: false }
        ],
        editedIndex: -1,
        editedItem: {
          name: "",
          subscriptionExpiry: ""
        },
        defaultItem: {
          name: ""
        },
        page: 1
      },
      domains: {
        domains: [],
        item: [],
        deleteLoading: false,
        deleteModal: false,
        headers: [
          { text: "Domain", value: "domain" },
          { text: "Contributed By", value: "user.username" },
          { text: "Active", value: "active" },
          { text: "Options", value: "options" }
        ]
      }
    }
  },
  methods: {
    actInvitesV2(type, item) {
      this.invitesV2.loading = true
      this.axios
        .patch("/api/v1/admin/invitesV2/" + item.id, {
          type
        })
        .then(() => {
          this.invitesV2.loading = false
          this.$toast.success("Invitation updated.")
          this.getInvitesV2()
        })
        .catch((e) => {
          this.invitesV2.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    getFeedback() {
      this.axios.get("/api/v1/admin/feedback").then((res) => {
        this.feedback = res.data
      })
    },
    createAnnouncement() {
      this.announcement.loading = true
      this.axios
        .post("/api/v1/admin/announcements/create", {
          content: this.announcement.content,
          type: this.announcement.type
        })
        .then(() => {
          this.announcement.loading = false
        })
        .catch((e) => {
          this.announcement.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    calculateCost(price) {
      return price / 100
    },
    addUserDebug() {
      this.axios
        .post("/api/v1/debug/createUser")
        .then((res) => {
          this.debug.users.user = res.data
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    getDomains() {
      this.axios
        .get("/api/v1/admin/domains/list")
        .then((res) => {
          this.domains.domains = res.data
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    doDeleteDomain() {
      this.domains.deleteLoading = true
      this.axios
        .put("/api/v1/admin/domains/delete", {
          domain: this.domains.item.domain
        })
        .then(() => {
          this.domains.deleteLoading = false
          this.getDomains()
          this.domains.deleteModal = false
          this.domains.item = []
        })
        .catch((e) => {
          this.domains.deleteLoading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    deleteDomain(item) {
      this.domains.item = item
      this.domains.deleteModal = true
    },
    dayjs(params) {
      return dayjs(params)
    },
    getReports() {
      this.axios
        .get("/api/v1/admin/reports/list/" + this.reports.page)
        .then((res) => {
          this.reports.reports = res.data.reportArray
          this.reports.pager = res.data.pager
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    getPlanDetails() {
      this.axios
        .get("/api/v1/admin/billing/plans")
        .then((res) => {
          this.users.plans = res.data
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    invalidate(key) {
      this.axios
        .put("/api/v1/admin/invite/invalidate", {
          inviteKey: key.id
        })
        .then(() => {
          this.getInviteKeys(true)
        })
        .catch((e) => {
          this.getInviteKeys(true)
          AjaxErrorHandler(this.$store)(e)
        })
    },
    doInviteLookup() {
      this.invites.lookup.loading = true
      this.axios
        .get("/api/v1/admin/invite/lookup/" + this.invites.lookup.invite)
        .then((res) => {
          this.invites.lookup.loading = false
          this.invites.lookup.result = res.data
        })
        .catch((e) => {
          this.invites.lookup.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    doInviteEntitlementForUser() {
      this.invites.loadingUser = true
      this.axios
        .put("/api/v1/admin/invite/wave/" + this.invites.username, {
          count: this.invites.count
        })
        .then(() => {
          this.invites.loadingUser = false
        })
        .catch((e) => {
          this.invites.loadingUser = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    doInviteEntitlement(count) {
      this.invites.loading = true
      this.axios
        .put("/api/v1/admin/invite/wave", {
          count
        })
        .then(() => {
          this.invites.loading = false
        })
        .catch((e) => {
          this.invites.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    getInviteKeys(init) {
      this.axios
        .get("/api/v1/admin/invite/list")
        .then((res) => {
          if (init) {
            this.invites.inviteKeys = res.data.rows
          } else {
            this.invites.inviteKeys.push(res.data.rows)
          }
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    editItem(item) {
      this.users.editedIndex = this.users.users.indexOf(item)
      this.users.editedItem = Object.assign({}, item)
      if (item.subscription) {
        this.users.editedItem.subscriptionExpiry = new Date(
          item.subscription.expiredAt
        )
          .toISOString()
          .substring(0, 10)
      }
      this.users.dialog = true
    },
    banUser(item, type) {
      this.axios
        .put("/api/v1/admin/user/ban/" + item.id, {
          type: type
        })
        .then(() => {
          this.getUsers(true)
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    purgeGalleryDialog(item) {
      this.users.purgeGallery.user = item
      this.users.purgeGallery.dialog = true
    },
    doPurgeGallery() {
      this.users.purgeGallery.loading = true
      this.axios
        .put(
          "/api/v1/admin/user/purgeGallery/" + this.users.purgeGallery.user.id
        )
        .then(() => {
          this.users.purgeGallery.loading = false
          this.users.purgeGallery.dialog = false
          this.getUsers(true)
        })
        .catch((e) => {
          this.users.purgeGallery.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    inviteBanUser(item, type) {
      this.axios
        .put("/api/v1/admin/user/inviteBan/" + item.id, {
          type: type
        })
        .then(() => {
          this.getUsers(true)
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    deleteItemConfirm() {
      this.users.splice(this.users.editedIndex, 1)
      this.closeDelete()
    },

    close() {
      this.users.dialog = false
      this.$nextTick(() => {
        this.users.editedItem = Object.assign({}, this.defaultItem)
        this.users.editedIndex = -1
      })
    },
    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.users.editedItem = Object.assign({}, this.defaultItem)
        this.users.editedIndex = -1
      })
    },
    save(item) {
      this.users.loading = true
      this.axios
        .put("/api/v1/admin/user/edit/" + item.id, {
          plan: item.planId,
          admin: item.admin,
          banned: item.banned,
          moderator: item.moderator,
          expiredAt: new Date(item.subscriptionExpiry)
        })
        .then(() => {
          this.users.loading = false
          this.users.dialog = false
          this.getUsers(true)
        })
        .catch((e) => {
          this.users.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    getUsers(init) {
      if (init) {
        this.page = 1
      }
      this.axios
        .get("/api/v1/admin/user/list/" + this.page)
        .then((res) => {
          if (init) {
            this.users.users = res.data.userArray
          } else {
            this.users.users.push(res.data.userArray)
          }
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    getInvitesV2() {
      this.axios
        .get("/api/v1/admin/invitesV2")
        .then((res) => {
          this.invitesV2.rows = res.data
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    }
  },
  mounted() {
    this.getUsers(true)
    this.getInviteKeys(true)
    this.getPlanDetails()
    this.getReports()
    this.getDomains()
    this.getFeedback()
    this.getInvitesV2()
  }
}
</script>

<style scoped></style>
